<script setup>

import {computed, inject} from 'vue'
import DocumentDownloadLayout from "@/components/common/other/DocumentDownloadLayout.vue";
import {useDownloadLocalFile} from "@/composables/common/useDownloadLocalFile";
import API from "@/classes/global/API";

const shipmentDocs = computed(() => {

  return props.modelValue.shipmentDocs
})

const props = defineProps({

  modelValue: {}
})

async function downloadDocument(doc) {

  doc.isDownloading = true;

  let response = await API.downloadDocument(doc.id);

  if(response) {

    useDownloadLocalFile(response);

    doc.downloaded = true;

  }

  doc.isDownloading = false;

}

</script>

<template>
  <DocumentDownloadLayout
      @download-document="downloadDocument"
      v-model="shipmentDocs">
  </DocumentDownloadLayout>
</template>

<style lang="scss" scoped>

</style>
